export function objectToCsv (data) {
    const csvRows = []

    const headers = Object.keys(data[0])
    csvRows.push(headers.join(';'))

    for (const row of data) {
        const values = headers.map(header => {
            const escaped = (''+row[header]).replace(/"/g, '\\"')
            return `"${escaped}"`
        })
        csvRows.push(values.join(';'))
    }

    return csvRows.join('\n')
}

export function downloadCsvReport (data) {
    const blob = new Blob([data], {type: 'text/csv'})
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.setAttribute('hidden', '')
    a.setAttribute('href', url)
    a.setAttribute('download', 'download.csv')
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
}



// WEBPACK FOOTER //
// ./src/shared/csvReport.js